<template>
    <v-card v-if="policy">
        <v-card-title>{{ policy.title }}</v-card-title>
        <v-card-text v-html="policy.content">
        </v-card-text>
    </v-card>
</template>

<script>

export default {
    name: "PrivacyPolicy",
    computed:{
        policy(){
            const policy = this.$store.state.resources.policy_and_terms.privacy_policy;
            policy.content = policy.content.replaceAll('\\r','').replaceAll('\\n','');
            return policy;
        },
    }
}
</script>
